import React, { useContext, useEffect, useState } from 'react';
import AgrupamentoDeAnimais from './body/agrupamentoAnimal';
import PosicoesContext from '../../../context/posicoes.context';
import ReservaLegal from './body/reservaLegal';
import Rios from './body/rios';
import Moradia from './body/moradia';
import Escola from './body/escola';
import Coleta from './body/coleta';
import Apicultura from './body/apicultor';
import Sericicultura from './body/sericicultor';
import Cultura from './body/cultura';
import { constantes } from '../../../constantes';
import Amoreira from './body/amoreira';
import Aplicador from './body/aplicador';

function ModalBody() {
  const {
    temp: { tipo },
    enableIputHeader: { estado: estadoValid, cidade: cidadeValid, tipo: tipoValid }, setTemp,
  } = useContext(PosicoesContext);
  const {
    rios, apicultura, escola, moradia, reserva, coleta,
    animal, sericicultura, cultura, amoreira, aplicador,
  } = constantes.classificacao;
  const [exibeModal, setExibeModal] = useState();

  useEffect(() => {
    if (estadoValid && cidadeValid && tipoValid) {
      setExibeModal(true);
    } else {
      setExibeModal(false);
      setTemp(() => ({
        positions: [{ lat: 0, lng: 0 }],
        tipo: 'Selecione',
      }));
    }
  }, [estadoValid, cidadeValid, tipoValid]);

  return (
    <>
      {exibeModal
      && (
      <>
        {tipo === rios && Rios() }
        {tipo === apicultura && Apicultura() }
        {tipo === escola && Escola() }
        {tipo === coleta && Coleta() }
        {tipo === moradia && Moradia() }
        {tipo === reserva && ReservaLegal() }
        {tipo === animal && AgrupamentoDeAnimais() }
        {tipo === sericicultura && Sericicultura() }
        {tipo === cultura && Cultura() }
        {tipo === amoreira && Amoreira() }
        {tipo === aplicador && Aplicador() }
      </>
      )}
    </>
  );
}

export default ModalBody;
